import ThankComp from "../components/thank_component/Thank";

const ThankP = () => {
    return ( 
        <>
       <ThankComp/>
        </>
     );
}
 
export default ThankP;